<router-outlet></router-outlet>
@if (rootName == "sessionGuard") {
  <div id="start">
    <img id="logo-start" src="assets/img/Cariloop_Icon_1024x1024.png" alt="" />
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
}

<app-toast
  id="toast"
  [message]="toastProperties.toastMessage | translate"
  [showsToast]="toastProperties.showToast"
  [state]="toastProperties.toastType"
  [title]="toastProperties.toastTitle | translate"
></app-toast>
